export default "/app/themes/skrzydlewska/assets/dist/images/icon-ribbon.png";